<template>
  <div class="row">
    <div class="col">
      <div class="card card-modern">
        <div class="card-body">
          <div class="datatables-header-footer-wrapper">
            <div class="datatable-header">
              <div class="row align-items-center d-flex justify-content-between mb-3">
                <div class="col-3 col-lg-4 mb-3 mb-lg-0">
                  <treeselect
                      v-model="approved"
                      class="w-100 custom-vue-tree-select"
                      :options="approvedOptions"
                      placeholder="Odobreno/Neodobreno"
                    />
                </div>
                <div
                  class="col-8 col-lg-auto ms-auto ml-auto mb-3 mb-lg-0"
                ></div>
                  <div
                    class="col-3 ps-lg-1 mb-3 mb-lg-0 d-flex justify-content-end align-items-center gap-1"
                  >
                  <div
                    class="d-flex align-items-lg-center flex-column flex-lg-row"
                  >
                    <label class="ws-nowrap me-3 mb-0">Show:</label>
                    <select
                      class="form-control select-style-1 results-per-page"
                      name="results-per-page"
                      v-model="searchConfig.pageSize"
                      @change="changePageSize(searchConfig.pageSize)"
                    >
                      <option
                        :value="page"
                        v-for="page in pageSizeList"
                        :key="page"
                      >
                        {{ page }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-lg-auto ps-lg-1">
                  <div
                    class="search search-style-1 search-style-1-lg mx-lg-auto"
                  >
                    <div class="input-group">
                      <input
                        type="text"
                        class="search-term form-control"
                        placeholder="Search"
                        v-model="searchField"
                        @input="debounceInput"
                      />
                      <button class="btn btn-default" type="submit">
                        <i class="bx bx-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="datatable-ecommerce-list_wrapper"
              class="dataTables_wrapper dt-bootstrap5 no-footer"
            >
              <div class="row justify-content-between">
                <div class="col-auto"></div>
                <div class="col-auto"></div>
              </div>
              <div class="table-responsive" v-if="list.length > 0">
                <table
                  class="
                    table table-ecommerce-simple table-striped
                    mb-0
                    dataTable
                    no-footer
                  "
                  id="datatable-ecommerce-list"
                  style="min-width: 750px"
                  role="grid"
                  aria-describedby="datatable-ecommerce-list_info"
                >
                  <thead>
                    <tr role="row">
                      <th class="sorting_disabled">
                        <input
                          type="checkbox"
                          class="select-all checkbox-style-1 p-relative top-2"
                          v-model="selectAll"
                        />
                      </th>
                      <th class="sorting">
                        Rbr
                      </th>
                      <th class="sorting">
                        Ime i prezime
                      </th>
                      <th class="sorting">
                        Kompanija
                      </th>
                      <th class="sorting">
                        Telefon
                      </th>
                      <th class="sorting">
                        E-mail
                      </th>
                      <th class="sorting">
                        Adresa
                      </th>
                      <th class="sorting">
                        Grad
                      </th>
                      <th class="sorting">
                        Aktivan?
                      </th>
                      <th class="sorting">
                        Datum kreiranja
                      </th>
                      <th class="sorting">
                        Akcije
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(user, index) in list" :key="user.id" :class="{ odd: index % 2 === 0, even: index % 2 !== 0 }">
                      <td width="30">
                        <input
                          type="checkbox"
                          class="checkbox-style-1 p-relative top-2"
                          :value="user.id"
                          v-model="selected"
                          @click.stop
                        />
                      </td>
                      <td>
                        <strong>{{ ((pager.currentPage - 1) * (searchConfig.pageSize)) + index + 1 }}</strong>
                      </td>
                      <td>
                        <strong>{{ `${user.firstName} ${user.lastName}` }}</strong>
                      </td>
                      <td>{{ user.companyTitle }}</td>
                      <td>{{ user.phoneNumber }}</td>
                      <td>{{ user.email }}</td>
                      <td>{{ user.address_1 || 'N/A' }}</td>
                      <td>{{ user.town || 'N/A'}}</td>
                      <td>
                        <span
                          class="badge text-2"
                          :class="{
                            'text-success bg-soft-success': user.isAccountApproved && user.isAccountVerified,
                            'text-danger bg-soft-danger': !user.isAccountApproved || !user.isAccountVerified
                        }">
                          {{ user.isAccountApproved && user.isAccountVerified? 'Da' : 'Ne' }}
                        </span>
                      </td>
                      <td>{{ formatDate(user.createdDate) }}</td>
                      <td>
                        <div class="btn-group" v-if="!user.approved">
                          <button type="button" class="btn" data-bs-toggle="dropdown" aria-expanded="false">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                              <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                            </svg>
                          </button>
                          <ul class="dropdown-menu">
                            <li @click="approveRequest(user.id)">
                              <a class="dropdown-item" href="#">Odobri zahtjev</a>
                            </li>
                            <li @click="declineRequest(user.id)">
                              <a class="dropdown-item" href="#">
                                Odbij i ukloni zahtjev
                              </a>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else>
                <div class="alert alert-info" role="alert">
                  {{ translations.noRecords }} <a class="alert-link" @click.prevent="resetFilters">{{ translations.resetFilters }}</a>.
                </div>
              </div>
            </div>
            <hr class="solid mt-5 opacity-4" />
            <div class="datatable-footer">
              <div class="row align-items-center justify-content-between mt-3">
                <div class="col-md-auto order-1 mb-3 mb-lg-0">
                  <div class="d-flex align-items-stretch">
                    <div
                      class="d-grid gap-3 d-md-flex justify-content-md-end me-4"
                    >
                      <select
                        class="form-control select-style-1 bulk-action"
                        name="bulk-action"
                        v-model="bulkAction"
                        style="min-width: 170px"
                      >
                        <option value="bulkAction">Bulk Actions</option>
                        <option value="delete">Delete</option>
                      </select>

                      <button
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#delete-modal"
                        class="bulk-action-apply text-color-dark text-3 btn btn-light border btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1">
                        {{ translations.apply }}
                      </button>
                      
                    </div>
                  </div>
                </div>
                <div class="row row-gutter-sm justify-content-between mt-4">
                  <pagination :action="actionName" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal id="delete-modal">
      <h5 slot="header"><strong>{{ translations.deleteSelected }}</strong></h5>
      <div slot="body">
        <span v-html="modalText">
        </span>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button type="button" class="btn btn-primary px-4 mx-2" @click.prevent.stop="handleBulkAction" data-bs-dismiss="modal">
              {{ translations.yes }}
            </button>
            <button type="button" class="btn btn-default px-4" data-bs-dismiss="modal">
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </modal>
    <!-- end: page -->
  </div>
</template>

<script>
import { pager, translations } from '@/mixins';
import api from '@/services/api';
import Pagination from '../shared/Pagination.vue';
import Modal from '@/components/shared/modal/Modal.vue';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  components: { Pagination, Modal, Treeselect },
  name: 'Users',
  mixins: [pager, translations],
  data() {
    return {
      actionName: 'getB2BCustomerRequests',
      deleteActionName: 'deleteB2BCustomerRequests',
      bulkActionName: 'deleteB2BCustomerRequests',
      filter: 1,
      approved: null,
    };
  },
  computed: {
    approvedOptions() {
      return [
        {id: '0', label: 'Neodobreno'},
        {id: '1', label: 'Odobreno'}
      ];
    },
    paginationProps() {
      return {
        approved: this.approved === '0' ? false : this.approved === '1' ? true : null,
      };
    },
    list() {
      return this.$store.getters.getB2BCustomerRequests;
    },
    modalText() {
      return this.translations.areYouSureSelected;
    },
  },
  methods: {
    filterUsers() {
      switch (this.filter) {
        case 1:
          this.$store.dispatch(this.actionName, {...this.searchConfig, ...this.paginationProps,});
          break;
        case 2:
          this.$store.dispatch(this.actionName, { ...this.searchConfig, ...this.paginationProps, notVerified: true });
          break;
        case 3:
          this.$store.dispatch(this.actionName, { ...this.searchConfig, ...this.paginationProps, notApproved: true });
          break;
      }
    },
    approveRequest(id) {
      api.approveB2BCustomerRequest(id).then((response) => {
        this.$toast.info(response?.data?.info);
      }).catch((err) => {
        this.$toast.info(err?.response?.data?.info);
      }).finally(() => {
        this.$store.dispatch(this.actionName, this.searchConfig);
      });
    },
    declineRequest(id) {
      api.declineB2BCustomerRequest(id).then((response) => {
        this.$toast.info(response?.data?.info);
      }).catch((err) => {
        this.$toast.info(err?.response?.data?.info);
      }).finally(() => {
        this.$store.dispatch(this.actionName, this.searchConfig);
      });
    },
  },
  mounted() {
    this.$store.dispatch(this.actionName, this.searchConfig);
  },
  watch: {
    approved() {
      this.filterUsers();
    },
  },
};
</script>

<style lang="scss">
.alert-link {
  cursor: pointer;
}
</style>

<style scoped>
.table-responsive {
  padding-bottom: 5px;
}

.custom-vue-tree-select .vue-treeselect__control {
  border: 1px solid #e7e7e7;
}
</style>